module.exports = __webpack_public_path__ + "img/user.03fa0433.png";